import HaggleEventPanel from '@/components/panel/haggle-event/HaggleEventPanel';

const AdminHagglesDashboard = () => {
	return <HaggleEventPanel />;
};
export default AdminHagglesDashboard;
